/**
 * HeaderTextZoom — compact "− T 100% +" text-size control for the dark site
 * header, harmonised with the ERIO app's top-right accessibility control.
 * Shares state/persistence with the footer control via lib/textZoom.
 */
import React, { useEffect, useState } from "react";
import { getZoom, setZoom, ZOOM_LEVELS } from "../lib/textZoom";

const HeaderTextZoom = () => {
  const [zoom, setZoomState] = useState(1);

  useEffect(() => {
    setZoomState(getZoom());
    const onChange = (e) => setZoomState(e.detail);
    window.addEventListener("ek-text-zoom-change", onChange);
    return () => window.removeEventListener("ek-text-zoom-change", onChange);
  }, []);

  const idx = ZOOM_LEVELS.indexOf(zoom);
  const decrease = () => setZoom(ZOOM_LEVELS[Math.max(0, idx - 1)]);
  const increase = () => setZoom(ZOOM_LEVELS[Math.min(ZOOM_LEVELS.length - 1, idx + 1)]);
  const pct = Math.round(zoom * 100);

  return (
    <div
      className="hidden lg:inline-flex items-center rounded-full border border-white/20 text-white/85"
      role="group"
      aria-label="Text size"
      data-testid="header-text-zoom"
    >
      <button
        type="button"
        onClick={decrease}
        disabled={idx <= 0}
        aria-label="Decrease text size"
        className="px-2.5 py-1.5 text-[15px] leading-none rounded-l-full hover:text-white disabled:opacity-40 disabled:cursor-not-allowed transition-colors"
        data-testid="header-text-zoom-smaller"
      >
        −
      </button>
      <span
        className="px-1 text-[11px] tracking-[0.04em] tabular-nums inline-flex items-center gap-1 text-white/70 select-none"
        data-testid="header-text-zoom-value"
      >
        <span className="text-[12px] font-medium">T</span> {pct}%
      </span>
      <button
        type="button"
        onClick={increase}
        disabled={idx >= ZOOM_LEVELS.length - 1}
        aria-label="Increase text size"
        className="px-2.5 py-1.5 text-[15px] leading-none rounded-r-full hover:text-white disabled:opacity-40 disabled:cursor-not-allowed transition-colors"
        data-testid="header-text-zoom-larger"
      >
        +
      </button>
    </div>
  );
};

export default HeaderTextZoom;
